angular.module('shared-components').component('gccsResourceList', {
  template: require('./template.pug'),
  controller: 'ResourceListController',
  bindings: {
    resources: '<',
    isResource: '<'
  }
});
